module.exports = __webpack_public_path__ + "static/media/Microbrew-Three-Inline-Regular.870b875f.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Microbrew-Three-Inline-Regular.otf
// module id = 3292
// module chunks = 70